import { PlusIcon } from "@phosphor-icons/react/dist/csr/Plus";
import { useRef } from "react";
import { Button } from "@volca/ui/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import type { EditorUpload } from "./use-editor-upload";

export const AttachButton = ({ upload }: { upload: EditorUpload }) => {
  const input = useRef<HTMLInputElement>(null);
  return (
    <>
      <Tooltip>
        <TooltipTrigger render={<span className="inline-flex" />}>
          <Button
            type="button"
            size="icon-sm"
            variant="ghost"
            className="text-subtle"
            aria-label="Attach files"
            disabled={!upload.available}
            onClick={() => input.current?.click()}
          >
            <PlusIcon className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {upload.full
            ? "20 files is the limit. Remove a file, or select an interrupted file to retry."
            : "Attach files (20 MB per file)"}
        </TooltipContent>
      </Tooltip>
      <input
        ref={input}
        type="file"
        multiple
        disabled={!upload.available}
        className="hidden"
        aria-label="Upload payroll files"
        onChange={(event) => {
          upload.selectFiles(Array.from(event.target.files ?? []));
          event.target.value = "";
        }}
      />
    </>
  );
};
